module.exports = __webpack_public_path__ + "static/img/logo.5a37275.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/yyk/logo.svg
// module id = 175
// module chunks = 0